export enum PartnershipCompanyConfig {
  DOCEBO_SHARED_SECRET = 'DOCEBO_SHARED_SECRET',
  HRIS_EMAIL = 'HRIS_EMAIL',
  HRIS_LOCATION = 'HRIS_LOCATION',
  IS_LEAVE_ENABLED = 'IS_LEAVE_ENABLED',
  IGNORE_EMPLOYEE_START_DATE = 'IGNORE_EMPLOYEE_START_DATE',
  IS_CONTRACTOR_SYNC_ENABLED = 'IS_CONTRACTOR_SYNC_ENABLED',
  INTELLUM_PARENT_CATEGORY_ID = 'INTELLUM_PARENT_CATEGORY_ID',
  LOCATION_OVERRIDE = 'LOCATION_OVERRIDE',
  IS_WORKDAY_CSV_PUSH_ENABLED = 'IS_WORKDAY_CSV_PUSH_ENABLED',
  IS_WORKDAY_CSV_PGP_ENCRYPTED = 'IS_WORKDAY_CSV_PGP_ENCRYPTED',
  THIRD_PARTY_PROVIDER = 'THIRD_PARTY_PROVIDER',
  EMPLOYEE_TYPE_FILTER = 'EMPLOYEE_TYPE_FILTER',
  EMAILS_TO_IGNORE = 'EMAILS_TO_IGNORE',
  MIN_SYNC_FREQUENCY_IN_HOURS = 'MIN_SYNC_FREQUENCY_IN_HOURS',
  VANTA_FRAMEWORK_COURSES = 'VANTA_FRAMEWORK_COURSES',
  VANTA_CAMPAIGN_SYNC_TYPE = 'VANTA_CAMPAIGN_SYNC_TYPE',
}
